import React, { useCallback, useContext, useEffect, useState } from 'react';
import Divider from '../../components/Divider';
import Header from '../../components/Header';
import {
  getMedias,
  getProfilesData,
  getAudityProcess,
  getAudityAction,
  getAudity,
} from '../../api/Api';
import dateUtils from '../../utilities/dateUtils';
import { ProfileContext } from '../../contexts/ProfileContext';
import TextFieldInput from '../../components/inputs/TextFieldInput';
import InputWithAutocomplete from '../../components/inputs/InputWithAutocomplete';
import FromToDateInput from '../../components/inputs/FromToDateInput';
import BulmaPagination from '../../components/Pagination';
import DropdownInput from '../../components/inputs/DropDownInput';
import { useLoadingContext } from '../../contexts/LoadingContext';

const RESULTSLIMITPERPAGE = process.env.REACT_APP_API_RESULTS_LIMIT || 10;

const BillsTable = ({ isAdmin, files }) => {
  const getActionColor = (action) => {
    const actionName = action.toLowerCase();
    if (actionName.includes('create') || actionName.includes('crear')) return 'is-success';
    if (actionName.includes('update') || actionName.includes('actualizar') || actionName.includes('edit')) return 'is-info';
    if (actionName.includes('delete') || actionName.includes('borrar') || actionName.includes('eliminar')) return 'is-danger';
    if (actionName.includes('login') || actionName.includes('logout')) return 'is-warning';
    return 'is-light';
  };

  return (
    <div className="box" style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', padding: '2rem' }}>
      
      <div className="table-container-stretched" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
        <table className="table is-fullwidth is-striped is-hoverable table-stretched">
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th className="has-text-weight-bold has-text-left" style={{ width: '12%', minWidth: '140px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-clock-o"></i>
                  </span>
                  <span>Fecha/Hora</span>
                </span>
              </th>
              <th className="has-text-weight-bold has-text-left" style={{ width: '15%', minWidth: '160px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-cogs"></i>
                  </span>
                  <span>Proceso/Módulo</span>
                </span>
              </th>
              <th className="has-text-weight-bold has-text-left" style={{ width: '12%', minWidth: '120px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-flash"></i>
                  </span>
                  <span>Acción</span>
                </span>
              </th>
              <th className="has-text-weight-bold has-text-left" style={{ width: '10%', minWidth: '120px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-key"></i>
                  </span>
                  <span>Clave Usuario</span>
                </span>
              </th>
              <th className="has-text-weight-bold has-text-left" style={{ width: '15%', minWidth: '140px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-user"></i>
                  </span>
                  <span>Afiliado</span>
                </span>
              </th>
              <th className="has-text-weight-bold has-text-left" style={{ width: '36%', minWidth: '250px' }}>
                <span className="icon-text">
                  <span className="icon is-small mr-2">
                    <i className="fa fa-info-circle"></i>
                  </span>
                  <span>Descripción</span>
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            {files.map((file, index) => (
              <React.Fragment key={index}>
                <tr 
                  className="hover-row"
                  style={{
                    transition: 'all 0.2s ease',
                    borderLeft: `4px solid ${file.user ? '#48c78e' : '#f39c12'}`,
                  }}
                >
                  <td className="is-vcentered has-text-left">
                    <span className="has-text-weight-medium has-text-dark">
                      {file.formatted_created_at}
                    </span>
                  </td>
                  <td className="is-vcentered has-text-left">
                    <span className="tag is-primary is-light has-text-weight-medium">
                      {file.action.audit_process.name}
                    </span>
                  </td>
                  <td className="is-vcentered has-text-left">
                    <span className={`tag ${getActionColor(file.action.name)} is-light has-text-weight-medium`}>
                      {file.action.name}
                    </span>
                  </td>
                  <td className="is-vcentered has-text-left">
                    <span className="has-text-weight-medium has-text-grey-dark">
                      {file.user_key}
                    </span>
                  </td>
                  <td className="is-vcentered has-text-left">
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {file.user ? (
                        <>
                          <span className="tag is-success is-light has-text-weight-medium mr-2">
                            User
                          </span>
                          <span className="has-text-weight-medium">
                            {file.user.user.username}
                          </span>
                        </>
                      ) : (
                        <>
                          <span className="tag is-warning is-light has-text-weight-medium mr-2">
                            System
                          </span>
                          <span className="has-text-weight-medium has-text-grey">
                            Sistema
                          </span>
                        </>
                      )}
                    </div>
                  </td>
                  <td className="is-vcentered has-text-left description-cell">
                    <div className="description-scrollable">
                      <span 
                        className="has-text-weight-medium has-text-grey-dark"
                        title={file.description}
                      >
                        {file.description}
                      </span>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ backgroundColor: '#f8f9fa' }}>
              <th className="has-text-weight-bold has-text-left">Fecha/Hora</th>
              <th className="has-text-weight-bold has-text-left">Proceso/Módulo</th>
              <th className="has-text-weight-bold has-text-left">Acción</th>
              <th className="has-text-weight-bold has-text-left">Clave Usuario</th>
              <th className="has-text-weight-bold has-text-left">Afiliado</th>
              <th className="has-text-weight-bold has-text-left">Descripción</th>
            </tr>
          </tfoot>
        </table>
      </div>
      
      {files.length === 0 && (
        <div className="has-text-centered" style={{ padding: '3rem' }}>
          <span className="icon is-large has-text-grey-light">
            <i className="fa fa-search fa-3x"></i>
          </span>
          <p className="title is-4 has-text-grey-light mt-4">No se encontraron registros</p>
          <p className="subtitle has-text-grey">Intenta ajustar los filtros de búsqueda</p>
        </div>
      )}
    </div>
  );
};

const Filters = ({
  medias,
  audityProcessData,
  audityAction,
  setAudityAction,
  fetchAudityActions,
  applyFilter,
  filters,
  setFilters,
  clearFilters,
}) => {
  const [mediaSearchTerm, setMediaSearchTerm] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const handleChangeDate = (event, field) => {
    const { value } = event.target;
    if (field === 'from') {
      setFromDate(value);
      handleOnChangeFilter(event, field);
    } else {
      setToDate(value);
      handleOnChangeFilter(event, field);
    }
  };

  const handleOnChangeFilter = (event, field) => {
    const filterChange = { [field]: event.target.value };
    setFilters({ ...filters, ...filterChange });
  };

  const handleClearFilters = async () => {
    setMediaSearchTerm([]);
    setFromDate('');
    setToDate('');
    await clearFilters();
  };

  return (
    <div
      className="box"
      style={{
        margin: '1rem 0',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        padding: '2rem',
      }}
    >

      {/* Primera fila de filtros */}
      <div className="columns is-multiline mb-2" style={{ marginBottom: '1rem' }}>
        <div className="column is-4">
          <div className="field">
            <InputWithAutocomplete
              title="Afiliado"
              suggestions={medias}
              searchTerm={mediaSearchTerm}
              setSeachTerm={setMediaSearchTerm}
            />
          </div>
        </div>

        <div className="column is-4">
          <div className="field">
            <DropdownInput
              title="Proceso"
              options={audityProcessData}
              setSelectedOption={(option) => {
                filters.action = '';
                setAudityAction(["Sin Accion"]);
                fetchAudityActions(option);
                setFilters({ ...filters, process: option });
              }}
              selectedOption={filters.process}
            />
          </div>
        </div>

        <div className="column is-4">
          <div className="field">
            <DropdownInput
              title="Acción"
              options={audityAction}
              setSelectedOption={(option) => {
                setFilters({ ...filters, action: option });
              }}
              selectedOption={filters.action}
            />
          </div>
        </div>
      </div>

      {/* Segunda fila de filtros */}
      <div className="columns is-multiline mb-2" style={{ marginBottom: '1rem' }}>
        <div className="column is-4">
          <div className="field">
            <FromToDateInput
              title="Período"
              fromDate={fromDate}
              toDate={toDate}
              onChangeFrom={(event) => handleChangeDate(event, 'from')}
              onChangeTo={(event) => handleChangeDate(event, 'to')}
            />
          </div>
        </div>

        <div className="column is-4">
          <div className="field">
            <TextFieldInput
              title="Descripción"
              value={filters.description}
              onChange={(event) => handleOnChangeFilter(event, 'description')}
            />
          </div>
        </div>

        <div className="column is-4">
          <div className="field">
            <TextFieldInput
              title="User Key"
              value={filters.user_key}
              onChange={(event) => handleOnChangeFilter(event, 'user_key')}
            />
          </div>
        </div>
      </div>

      {/* Botones de acción */}
      <div className="has-text-right" style={{ marginTop: '2rem' }}>
        <div className="field is-grouped is-grouped-right">
          <div className="control">
            <button
              className="button is-light is-normal"
              onClick={handleClearFilters}
              style={{
                borderRadius: '8px',
                transition: 'all 0.2s ease',
              }}
            >
              <span className="icon">
                <i className="fa fa-times-circle"></i>
              </span>
              <span>Limpiar filtros</span>
            </button>
          </div>
          <div className="control">
            <button
              className="button is-primary is-normal"
              onClick={() => applyFilter({ user: mediaSearchTerm, from: fromDate, to: toDate })}
              style={{
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0, 123, 255, 0.3)',
              }}
            >
              <span className="icon">
                <i className="fa fa-search"></i>
              </span>
              <span>Consultar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const EmptyFiltersObject = {
  action: '',
  process: '',
  user_key: '',
  description: '',
  user: '',
  from: '',
  to: '',
};

const AudityPage = () => {
  const [files, setFiles] = useState([]);
  const { setLoading } = useLoadingContext();
  const [pagination, setPagination] = useState({
    count: 0,
    limit: RESULTSLIMITPERPAGE,
    currentPage: 1,
    offset: 0,
  });
  const [medias, setMedias] = useState([]);
  const [audityProcess, setAudityProcess] = useState([]);
  const [audityAction, setAudityAction] = useState(["Seleccione un proceso"]);
  const [filters, setFilters] = useState(EmptyFiltersObject);
  const { profile, isLoadingProfile } = useContext(ProfileContext);

  const fetchAudity = useCallback((page = 1, options = {}) => {
    const { limit } = pagination;
    let offset;
    if (page === 1) {
      offset = 0;
    } else {
      offset = (page - 1) * limit;
    }
    setLoading(true);
    getAudity(limit, offset, options).then(({ json }) => {
      const { count, results } = json;
      const newPagination = pagination;
      newPagination.count = count;
      newPagination.currentPage = page;
      setPagination(newPagination);
      setFiles(results);
      setLoading(false);
    });
  }, []);

  const fetchAudityActions = async (process = "") => {
    const json = await getAudityAction(process);
    const actionNames = ["Sin accion"];
    json.forEach((action) => {
      actionNames.push(action.name);
    });
    setAudityAction(actionNames);
  };

  useEffect(() => {
    const fetchMedias = async () => {
      const json = await getProfilesData();
      setMedias(json.map((user) => user.user.username));
    };

    const fetchAudityProcess = async () => {
      const json = await getAudityProcess();
      const processNames = ["Sin Proceso"];
      json.forEach((process) => {
        processNames.push(process.name);
      });
      setAudityProcess(processNames);
    };

    fetchMedias();
    fetchAudityProcess();
    fetchAudity();
  }, []);

  const onClickPageNumber = async (pageNumber) => {
    setLoading(true);
    const options = { ...filters };
    await fetchAudity(pageNumber, options);
    setLoading(false);
  };

  const clearFilters = async () => {
    setFilters(EmptyFiltersObject);
    setLoading(true);
    await fetchAudity();
    setLoading(false);
  };

  const Pagination = () => {
    const { currentPage, count, limit } = pagination;
    return (
      <section className="section">
        <div className="columns is-centered">
          <div className="column is-half">
            <BulmaPagination
              pages={Math.ceil(count / limit)}
              currentPage={currentPage}
              onChange={(page) => onClickPageNumber(page)}
            />
          </div>
        </div>
      </section>
    );
  };

  const applyFilter = async (extraFilters = {}) => {
    const newFilters = { ...filters, ...extraFilters };
    const { from, to } = newFilters;
    if (from) {
      const fromString = dateUtils.getDjangODate(from);
      newFilters.from = fromString;
    }
    if (to) {
      const toString = dateUtils.getDjangODate(to);
      newFilters.to = toString;
    }
    await fetchAudity(1, newFilters);
  };

  if (isLoadingProfile) {
    return (
      <div className="section">
        <div className="container has-text-centered">
          <div className="box" style={{ borderRadius: '12px', padding: '3rem' }}>
            <span className="icon is-large has-text-primary">
              <i className="fa fa-spinner fa-pulse fa-3x"></i>
            </span>
            <p className="title is-4 mt-4">Cargando...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      
      {/* ✅ HEADER PRINCIPAL MODERNIZADO */}
      <section className="section" style={{ paddingBottom: '1rem' }}>
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-10">
              <div 
                className="box has-text-centered"
                style={{
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '2rem',
                  margin: '0',
                }}
              >
                <h1 className="title is-3 has-text-white has-text-weight-bold mb-3">
                  <span className="icon-text">
                    <span className="icon is-large mr-3">
                      <i className="fa fa-search fa-2x"></i>
                    </span>
                    <span>Auditoría General</span>
                  </span>
                </h1>
                <p className="subtitle is-5 has-text-white-ter">
                  Monitorea y revisa todas las actividades del sistema con filtros avanzados
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ✅ FILTROS Y TABLA */}
      <section className="section" style={{ paddingTop: '0' }}>
        <div className="container">
          {profile.is_admin && (
            <Filters
              filters={filters}
              setFilters={setFilters}
              medias={medias}
              audityProcessData={audityProcess}
              audityAction={audityAction}
              setAudityAction={setAudityAction}
              fetchAudityActions={fetchAudityActions}
              applyFilter={applyFilter}
              clearFilters={clearFilters}
            />
          )}
          
          <BillsTable isAdmin={profile.is_admin} files={files} setLoading={setLoading} />
        </div>
      </section>

      {/* ✅ PAGINACIÓN */}
      <Pagination />

      {/* ✅ ESTILOS CSS MEJORADOS */}
      <style jsx>{`
        .hover-row:hover {
          background-color: rgba(0, 0, 0, 0.05) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        /* Tabla más estirada */
        .table-stretched {
          table-layout: fixed;
          width: 100% !important;
        }

        .table-container-stretched {
          width: 100%;
          max-width: none;
          overflow-x: auto;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .table th, .table td {
          padding: 1rem 0.75rem;
          vertical-align: middle;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }

        .table th {
          background-color: #f8f9fa;
          border-bottom: 2px solid #dee2e6;
          position: sticky;
          top: 0;
          z-index: 10;
        }

        /* Descripción con scroll */
        .description-cell {
          max-width: 350px;
          position: relative;
        }

        .description-scrollable {
          max-height: 60px;
          overflow-y: auto;
          overflow-x: hidden;
          line-height: 1.4;
          word-break: break-word;
          overflow-wrap: break-word;
          white-space: pre-wrap;
          padding-right: 4px;
          scrollbar-width: thin;
          scrollbar-color: #c1c1c1 #f1f1f1;
        }

        /* Scrollbar personalizada para la descripción */
        .description-scrollable::-webkit-scrollbar {
          width: 6px;
        }

        .description-scrollable::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }

        .description-scrollable::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 3px;
        }

        .description-scrollable::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }

        /* Fade effect para indicar que hay más contenido */
        .description-scrollable::after {
          content: '';
          position: absolute;
          bottom: 0;
          right: 0;
          width: 20px;
          height: 20px;
          background: linear-gradient(45deg, transparent 50%, rgba(248, 249, 250, 0.8) 50%);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .description-cell:hover .description-scrollable::after {
          opacity: 1;
        }

        .tag {
          font-weight: 600;
          border-radius: 20px;
        }

        .box {
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .field .label {
          color: #4a4a4a;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .columns {
          margin-bottom: 0.5rem !important;
        }

        .column {
          padding: 0.5rem !important;
        }

        .icon-text {
          align-items: center;
        }

        /* Botón expandir/contraer - REMOVIDO */

        /* Responsive mejorado */
        @media screen and (max-width: 1200px) {
          .table th:nth-child(1) { width: 10%; }
          .table th:nth-child(2) { width: 12%; }
          .table th:nth-child(3) { width: 10%; }
          .table th:nth-child(4) { width: 8%; }
          .table th:nth-child(5) { width: 12%; }
          .table th:nth-child(6) { width: 48%; }
        }

        @media screen and (max-width: 768px) {
          .columns {
            margin: 0 !important;
          }

          .column {
            padding: 0.4rem !important;
          }

          .table-container-stretched {
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;
          }

          .table th, .table td {
            padding: 0.5rem 0.4rem;
            font-size: 0.85rem;
          }

          .field.is-grouped.is-grouped-right {
            justify-content: center;
          }

          .description-cell {
            max-width: 250px;
          }

          .description-scrollable {
            max-height: 50px;
          }
        }

        /* Mejoras en la accesibilidad */
        .button:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }

        /* Animaciones suaves */
        .box,
        .button,
        .hover-row {
          transition: all 0.3s ease;
        }

        /* Scrollbar personalizada para la tabla */
        .table-container-stretched::-webkit-scrollbar {
          height: 8px;
        }

        .table-container-stretched::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        .table-container-stretched::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }

        .table-container-stretched::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </div>
  );
};

export default AudityPage;